var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("connection-settings-popup", {
    attrs: {
      "is-new": _vm.isNew,
      invalid: _vm.$v.$invalid,
      "comment-id": _vm.commentId,
      resources: {
        deletePromptTitle: _vm.resource(
          "JourneyBuilder_DedupTarget_Delete_Title"
        ),
        deletePromptBody: _vm.resource("JourneyBuilder_DedupTarget_Delete_Body")
      }
    },
    on: {
      save: function($event) {
        return _vm.save()
      },
      delete: function($event) {
        return _vm.deleteCheckpoint()
      },
      "display-errors": function($event) {
        return _vm.displayErrors()
      },
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("h3", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.resource(
                      "JourneyBuilder_DeduplicationTargetSettings_Title"
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("help-popover", {
              attrs: {
                title: _vm.resource(
                  "JourneyBuilder_DeduplicationTargetSettings_Title"
                ),
                content: _vm.resource(
                  "JourneyBuilder_DeduplicationTargetSettings_Description"
                )
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("h4", [
              _vm._v(
                _vm._s(
                  _vm.resource("JourneyBuilder_JourneyBrick_SettingsHeader")
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default mb-2",
                attrs: { disabled: !_vm.canWrite },
                on: { click: _vm.addField }
              },
              [
                _c("i", { staticClass: "fas fa-plus" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.resource(
                        "SettingsDivisionMiscellaneous_Index_AddFieldButton_Text"
                      )
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.dedupFields, function(field, index) {
              return _c(
                "div",
                { staticClass: "row mt-3" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "col-2 field-label",
                      attrs: { for: "field_" + index }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "JourneyBuilder_DeduplicationSettings_FieldName"
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "col-7 form-control",
                    attrs: {
                      "input-id": "field_" + index,
                      clearable: false,
                      options: _vm.availableFields,
                      disabled: !_vm.canWrite
                    },
                    model: {
                      value: _vm.dedupFields[index],
                      callback: function($$v) {
                        _vm.$set(_vm.dedupFields, index, $$v)
                      },
                      expression: "dedupFields[index]"
                    }
                  }),
                  _vm._v(" "),
                  _vm.canWrite
                    ? _c(
                        "div",
                        {
                          staticClass: "col-3 btn btn-link",
                          on: {
                            click: function($event) {
                              return _vm.removeField(index)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "far fa-trash-alt" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.resource(
                                  "SettingsDivisionMiscellaneous_Index_DeleteFieldButton_Text"
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.$dirty && _vm.$v.dedupFields.$each[index].$invalid
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [_c("required-error-message")],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            _vm._v(" "),
            !_vm.$v.dedupFields.required
              ? _c("error-message", {
                  staticClass: "d-block",
                  attrs: {
                    message: _vm.resource(
                      "JourneyComposer_DedupField_ErrorMessage"
                    )
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-2" }, [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "JourneyBuilder_DeduplicationSettings_Term_Label"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-10" },
                [
                  _c("time-period", {
                    attrs: { disabled: !_vm.canWrite, clearable: "" },
                    model: {
                      value: _vm.term,
                      callback: function($$v) {
                        _vm.term = $$v
                      },
                      expression: "term"
                    }
                  })
                ],
                1
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }